import Chart from 'chart.js/auto';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.chart = new Chart(
      this.element,
      JSON.parse(this.element.dataset.chartData)
    );
  }
}
